import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './login/guard/auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { ServicePermissionsGuard } from './shared/guards/service-permissions.guard';
// import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './login/change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MMCPermissionsGuard } from './shared/guards/mmc-permission.guard';
import { AuthCallbackComponent } from './login/auth-callback.component';
import { userDataResolver } from './dashboard/resolver/user-data.resolver';
import { ResetPasswordLoginResolver } from './login/resolvers/reset-password-login.resolver';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'shared',
    loadChildren: () => import('./seatingchartviewer/shared-simulation/shared-simulation.routes').then(m => m.ROUTES),
  },
  {
    path: 'public/catalog/views',
    loadChildren: () => import('./catalog/public-view/public-catalog.module').then(m => m.PublicCatalogModule),
  },
  {
    path: 'public/catalog/collections',
    loadChildren: () =>
      import('./catalog/public-collection/public-collection.module').then(m => m.PublicCollectionModule),
  },
  {
    path: '',
    component: MainLayoutComponent,
    resolve: { 
      user: userDataResolver, 
    },
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'editor2dmaps',
        loadChildren: () => import('./2d-maps-editor/maps-editor.module').then(m => m.MapsEditorModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'authentication',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'venues',
        loadChildren: () => import('./venues/venues.module').then(m => m.VenuesModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'seating-data-viewer',
        loadChildren: () =>
          import('./seatingchartviewer/seatingchartviewer.module').then(m => m.SeatingchartviewerModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'sitesbuilder',
        loadChildren: () => import('./sites-builder/sites-builder.module').then(m => m.SitesBuilderModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'content-distribution',
        loadChildren: () =>
          import('./content-distribution/content-distribution.module').then(m => m.ContentDistributionModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'content-uploader',
        loadChildren: () => import('./content-uploader/content-uploader.module').then(m => m.ContentUploaderModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'catalog',
        loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'mlb-pricescales',
        loadChildren: () => import('./mlb-pricescales/mlb-pricescales.module').then(m => m.MLBPriceScalesModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'availability-manager',
        loadChildren: () =>
          import('./availability-manager/availability-manager.module').then(m => m.AvailabilityManagerModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'aws',
        loadChildren: () => import('./aws/aws.module').then(m => m.AWSModule),
        canActivate: [MMCPermissionsGuard],
      },
      {
        path: 'amenity-system',
        loadChildren: () =>
          import('./amenity-management-system/amenity-management-system.module').then(
            m => m.AmenityManagementSystemModule
          ),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'billing',
        loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule),
        canActivate: [ServicePermissionsGuard],
      },
      {
        path: 'translations',
        loadChildren: () => import('./translations/translations.module').then(m => m.TranslationsModule),
        canActivate: [MMCPermissionsGuard],
      },
    ],
  },
  {
    path: 'login',
    // component: LoginComponent,
    component: AuthCallbackComponent,
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'forgot',
    component: ForgotPasswordComponent,
    resolve: {
      user: ResetPasswordLoginResolver,
    },
  },
  {
    path: 'update-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: 'notfound',
    redirectTo: 'error',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
